<script>
export default {
  name: 'BookingLocationListItemSkeleton',
}
</script>

<template>
  <v-skeleton-loader
    loading
    class="rounded-xl custom-elevation booking-location-list-item__skeleton"
    type="image"
  ></v-skeleton-loader>
</template>

<style lang="scss" scoped>
@import '@styles';

::v-deep.booking-location-list-item__skeleton.v-skeleton-loader--is-loading {
  .v-skeleton-loader__image {
    height: 140px;
  }
}
</style>
